// extracted by mini-css-extract-plugin
module.exports = {"para":"about-module--para--3tOeE","link":"about-module--link--3h97c"};